<template lang="pug">
.sv-upload-light(
    :class="{ 'sv-upload-light--loaded': preview, 'sv-upload-light--hovered': hovered, 'without-image': !isImage && preview }"
    @mouseover="over(true)"
    @mouseleave="over(false)"
)
    .sv-upload-light__label
        SvButton.sv-upload-light__button(
            v-if="!withRemove"
            view="bordered"
            :text="buttonLabel"
        )

        .sv-upload-light__button-container

          SvButton.sv-upload-light__button-change(
            view="shadow"
            icon
            :prependIcon=`{
                icon: 'edit',
                width: 28,
                height: 28,
                hover: '#1993EB',
                default: '#B7BAC6'
            }`
            @click="imitationLoad"
          )

          SvButton.sv-upload-light__button-remove(
            view="shadow"
            icon
            :prependIcon=`{
                icon: 'trash',
                width: 24,
                height: 24,
                hover: '#1993EB',
                default: '#B7BAC6'
            }`
            @click="remove"
          )

        input.sv-upload-light__input(
            ref="inputPhoto"
            type="file"
            @change="uploaded"
        )

        .image-wrapper
          img.sv-upload-light__preview(
              v-if="preview && isImage"
              :src="preview"
          )
</template>

<script>
import SvButton from '@/components/uikit/SvButton.vue';

export default {
  name: 'SvUploadLight',

  model: {
    prop: 'preview',
    event: 'input',
  },

  data() {
    return {
      hovered: false,
    };
  },

  props: {
    preview: {
      type: String,
      default: null,
    },

    withRemove: {
      type: Boolean,
      default: false,
    },
    isImage: {
      type: Boolean,
      default: true
    }
  },

  components: {
    SvButton,
  },

  computed: {
    buttonLabel() {
      return this.preview ? 'Изменить' : 'Загрузить';
    },
  },

  methods: {
    uploaded(arg) {
      // const preview = window.URL.createObjectURL(arg.target.files[0]);
      const reader = new FileReader();
      reader.readAsDataURL(arg.target.files[0]);
      reader.onload = () => {
        this.$emit('input', reader.result);
      };
      // this.$emit('input', preview);
      this.$emit('inputedFile', arg.target.files[0]);
    },

    over(val) {
      this.hovered = val;
    },

    remove() {
      this.$emit('remove');
    },

    imitationLoad() {
      this.$refs.inputPhoto.click();
    }
  },
};
</script>

<style lang="scss">
.sv-upload-light {
    position: relative;
    width: 160px;
    height: 130px;
    overflow: hidden;
    border-radius: 4px;


    &.without-image {
      width: 100%;
      height: 100%;
    }

    &--loaded {
        .sv-upload-light__container {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 45px);
            width: 190px;
            display: flex;
            justify-content: center;
            opacity: 0;
        }

        .sv-upload-light__button-change {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 45px);
            width: 40px;
            display: flex;
            justify-content: center;
            opacity: 0;
            z-index: 20;
        }

        .sv-upload-light__button-remove {
            position: absolute;
            top: calc(50% - 20px);
            right: calc(50% - 45px);
            width: 40px;
            display: flex;
            justify-content: center;
            opacity: 0;
            z-index: 20;
        }

        .sv-upload-light__button {
            position: absolute;
            top: calc(50% - 20px);
            left: calc(50% - 45px);
            width: 40px;
            display: flex;
            justify-content: center;
            opacity: 0;
        }

        &.sv-upload-light--hovered {
            .sv-upload-light__label {
                height: 100%;
                // cursor: pointer;
            }

            .sv-upload-light__label:before {
                content: '';
                // cursor: pointer;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(255, 255, 255, .7);
            }
        }
    }

    &--hovered {
        .sv-upload-light__button {
            // cursor: pointer;
            transition: opacity ease-in-out .2s;
            opacity: 1;
        }

        .sv-button .sv-button__button {
          background:white;
        }


        .sv-upload-light__button-change,
        .sv-upload-light__button-remove,
        .sv-upload-light__container {
            transition: opacity ease-in-out .2s;
            opacity: 1;
        }
    }

    &__input {
        // opacity: 0;
        // position: absolute;
        // width: 100%;
        // height: 100%;
        // cursor: pointer;
        // top: 0;
        // left: 0;
        // right: 0;
        // bottom: 0;
        display: none;
    }

    &__preview {
        min-width: 100%;
        min-height: 100%;
        max-width: 140%;
        max-height: 140%;
    }

    .image-wrapper {
      width: 160px;
      height: 130px;
      overflow: hidden;
    }
}
</style>
